<script>
export default {
  translate25Context: ["vfigma"],
  props: {
    input: String,
    placeholder: String,
    disabled: Boolean,
    optional: Boolean,
    generator: Boolean,
    generate: Function,
    error: Boolean,
    showpassword: {
      type: Boolean,
      default: false,
    },
    change: Function,
  },
  data() {
    return {
      capslocked: false,
      focused: false,
    };
  },
};
</script>

<template>
  <f-field
    :optional="optional"
    :focused="focused"
    :class="{ disabled }"
    :error="error"
  >
    <template v-slot:label><slot name="label"></slot></template>
    <template v-slot:content>
      <div
        class="f-input-container"
        :class="{ focus: focused, capslocked: capslocked, error }"
      >
        <input
          class="keepfocus f-input"
          :value="input"
          :placeholder="placeholder"
          :class="{ disabled }"
          @keydown="
            capslocked = $event.getModifierState('CapsLock') ? true : false
          "
          @focus="focused = true"
          @blur="$emit('blur', $event);focused = false"
          @input="
            $emit('change', $event.target.value);
            $emit('update:input', $event.target.value);
          "
          :type="showpassword ? 'text' : 'password'"
        />
        <div class="capslocked_icon"></div>
        <div class="f-right">
          <div
            class="showpassword"
            @click="showpassword = true"
            v-if="!showpassword"
          >
            {{ $vt('SHOW') }}
          </div>
          <div
            class="showpassword"
            @click="showpassword = false"
            v-if="showpassword"
          >
            {{ $vt('HIDE') }}
          </div>
          <div class="f-action">
            <div v-if="generator" class="f-generator">
              <f-button type="tertiary" @click="$emit('generate', $event)">
                <f-icon icon="fa6-arrows-rotate"></f-icon>
              </f-button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:helper v-if="$slots.helper"
      ><slot name="helper"></slot
    ></template>
  </f-field>
</template>

<style scoped lang="scss">
.f-input-container {
  .showpassword {
    cursor: pointer;
    font-size: 12px;
    font-weight: bold;
    color: var(--navigation);
  }
}
.f-input-container.capslocked input.f-input {
  padding-left: 32px;
}

.capslocked_icon {
  display: none;
  position: absolute;
  background-image: url("assets/caps.png");
  background-size: 10px;
  background-repeat: no-repeat;
  background-position: center right;
  width: 25px;
  height: 100%;
  left: 0;
  top: 0;
}

.f-input-container.capslocked .capslocked_icon {
  display: flex;
}

.f-field.disabled .showpassword {
  opacity: 0.25;
}
</style>